import React from 'react'

import EditIcon from '@mui/icons-material/Edit'
import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableFooter,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Span
} from 'components'
import { DeleteIcon } from 'components/Icons'
import { useModal, useLoading, useException } from 'hooks'
import { IHandleChangePage, IHandleChangeRowsPerPage } from 'hooks/useGet'
import {
  IPaginatedEntityGST,
  IResponseTypes
} from 'services/core/genericEntityGST'
import {
  IGetAllItemsResponse,
  CadastroSegurancaItensSubItensServices
} from 'services/GST/CadastroItensSubitensSeguranca'
import { COLORS } from 'utils'

import { useSecurityItensAndSubItens } from '../../../../../../context'

interface ITableItemsProps {
  data: IPaginatedEntityGST<IGetAllItemsResponse[]>
  refresh: (_params: { pageNumber: number }) => void
  page: number
  rowsPerPage: number
  handleChangePage: IHandleChangePage
  handleChangeRowsPerPage: IHandleChangeRowsPerPage
}

const TableItems: React.FC<ITableItemsProps> = ({
  data,
  refresh,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage
}) => {
  const { handleSelectItemForEdit, handleSelectItem } =
    useSecurityItensAndSubItens()
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const { createCustomException, getException } = useException()

  const handleDeleteItemSeguranca = (
    selectedItemSeguranca: IGetAllItemsResponse
  ) => {
    showModal({
      handleConfirm: () => {
        setLoading('loading')

        CadastroSegurancaItensSubItensServices()
          .deleteItemSeguranca(selectedItemSeguranca.idItemSeguranca)
          .then((response) => {
            if (response.status !== 200) {
              const { tipo, detalhe, mensagem } = response.data

              createCustomException({
                detalhe,
                mensagem,
                tipo: IResponseTypes[tipo]
              })
            }

            showModal({
              hideButtonCancel: true,
              message: `Item de segurança ${selectedItemSeguranca.nmItemSeguranca} deletado com sucesso!`,
              txtButtonConfirm: 'OK',
              type: 'success'
            })
            refresh({
              pageNumber: 1
            })
            setLoading('idle')
          })
          .catch((err: Error) => {
            setLoading('idle')
            const error = getException(err)

            showModal({
              hideButtonCancel: true,
              message:
                error.mensagem ||
                err.message ||
                'Não foi possível deletar o item',
              txtButtonConfirm: 'OK',
              type: error.tipo || 'error'
            })
          })
      },
      message: `Tem certeza de que deseja apagar o item de segurança ${selectedItemSeguranca.nmItemSeguranca}?`,
      titleModal: 'Atenção',
      txtButtonCancel: 'Cancelar',
      txtButtonConfirm: 'Sim',
      type: 'alert'
    })
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="20px"></TableCellStyled>
              <TableCellStyled minwidth="20px">Item</TableCellStyled>
              <TableCellStyled minwidth="20px">
                Descrição do item
              </TableCellStyled>
              <TableCellStyled minwidth="50px">Legislação</TableCellStyled>
              <TableCellStyled minwidth="50px">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {data?.entity?.items?.length > 0 &&
              data?.entity?.items.map((row: IGetAllItemsResponse) => (
                <TableRowStyled key={`${row.idItemSeguranca}`}>
                  <TableCellStyled align="center">
                    <Span
                      text={String(row.idItemSeguranca)}
                      color={COLORS.blueFonts}
                    />
                  </TableCellStyled>
                  <TableCellStyled onClick={() => handleSelectItem(row)}>
                    <Span
                      text={row.nmItemSeguranca || '- - - - - - - - '}
                      color={COLORS.blueFonts}
                    />
                  </TableCellStyled>
                  <TableCellStyled>
                    {row.dsItemSeguranca || '- - - - - - - - '}
                  </TableCellStyled>
                  <TableCellStyled>
                    {row.txLegislacaoItemSeguranca || '- - - - - - - - '}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <EditIcon
                      fontSize="small"
                      onClick={() => handleSelectItemForEdit({ item: row })}
                    />
                    <DeleteIcon
                      cursor="pointer"
                      onClick={() => handleDeleteItemSeguranca(row)}
                    />
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={data?.entity?.items}
        totalItems={data?.entity?.pageCount}
        typeFooter="online"
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

export default TableItems
